module.exports = __webpack_public_path__ + "static/media/On_iphone@2x.b12890f9.png";